module.exports = __webpack_public_path__ + "media/01_final.b3d87ecb.mp4";